// loaders.ts
import { getSpConfig } from './getSpConfig'
import { injectScript } from './utils'

export function loadSpQueueConfig(): HTMLScriptElement | null {
  const config = getSpConfig()

  const spQueueConfig = `
  window._sp_queue = [];
  window._sp_ = {
    config: {
      accountId: ${config.accountId},
      baseEndpoint: '${config.baseEndpoint}',
      gdpr: {},
      events: {
        onMessageChoiceSelect: function () {
          console.log('[event] onMessageChoiceSelect', arguments);
        },
        onMessageReady: function () {
          console.log('[event] onMessageReady', arguments);
        },
        onMessageChoiceError: function () {
          console.log('[event] onMessageChoiceError', arguments);
        },
        onPrivacyManagerAction: function () {
          console.log('[event] onPrivacyManagerAction', arguments);
        },
        onPMCancel: function () {
          console.log('[event] onPMCancel', arguments);
        },
        onMessageReceiveData: function () {
          console.log('[event] onMessageReceiveData', arguments);
        },
        onSPPMObjectReady: function () {
          console.log('[event] onSPPMObjectReady', arguments);
        },
        onConsentReady: function (consentUUID, euconsent) {
          console.log('[event] onConsentReady', arguments);
        },
        onError: function () {
          console.log('[event] onError', arguments);
        },
      }
    }
  };
  `

  return injectScript({
    id: 'sp-queue-config',
    content: spQueueConfig,
    type: 'text/javascript',
    async: true,
  })
}
